import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import principalOne from "../../../../src/docs/assets/dancers/principal-artists1.jpg";
import principalTwo from "../../../../src/docs/assets/dancers/principal-artists2.jpg";
import soloists from "../../../../src/docs/assets/dancers/first-soloists.jpg";
import solo from "../../../../src/docs/assets/dancers/solist-demisolists.jpg";
import artistsOne from "../../../../src/docs/assets/dancers/artists1.jpg";
import artistsTwo from "../../../../src/docs/assets/dancers/artists2.jpg";
import artistsThree from "../../../../src/docs/assets/dancers/artists3.jpg";
import two from "../../../../src/docs/assets/dancers/ballet-west-II.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  principalOne,
  principalTwo,
  soloists,
  solo,
  artistsOne,
  artistsTwo,
  artistsThree,
  two,
  React
};